import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";
import GeneralesPoliza from "./generales.cmpt";
import ContratantePoliza from "./contratante.cmpt";
import VehiculoPoliza from "./vehiculo.cmpt";
import CobranzaPoliza from "./cobranza.cmpt";
import ConductorPoliza from "./conductor.cmpt";
import BeneficiarioPoliza from "./beneficiario.cmpt";
import AseguradosPoliza from "./asegurado.cmpt";
import InformacionFinancieraPoliza from "./informacion-financiera.cmpt";
import DescargasPoliza from "./descargas.cmpt";
import PagoPoliza from "./pago.cmpt.js";
import DescargaFacturas from "./descargaFacturas.cmpt";
import DescargaRecibos from "./descargaRecibos.cmpt";
import DescargaEdoCuenta from "./descargaEdoCuenta.cmpt";
import DescargaFiniquitos from "./descargaFiniquitos.cmpt";
import TarjetaCirculacion from "./tarjetaCirculacion.cmpt";
import DetallePagoPorKilometro from "./detallePagoPorKilometro.cmpt";
import Dentalia from "./dentalia.cmpt";
import {dentaliaBeneficios,obtenerTratamientoDentalia } from "./dentalia.act";
import MulticanalFlujos from "../gnp-multicanal/multicanalFlujos.cmpt";
import PhotosMascotaCmpt from "./photosMascota.cmpt";
import TarjetaVacunacion from "./tarjetaVacunacion.cmpt";
import {getData} from "../functions/rest-api";
import { Producto_Comercial, replaceErrorOnMascota } from "../constants/constants";
import regeneratorRuntime from "regenerator-runtime";
import { UtilModal } from "../mascotas/util-modal";
import { getVelidateIsMascota } from "../mascotas/util-functions";
import TarjetasFrame from "../tarjetas-frame/tarjetas-frame.cmpt";

const mapState = (state) => {
	return {
		"loading": state.global.loading,
		"polizaSeleccionada": state.polizas.polizaSeleccionada,
		"poliza": state.polizas.poliza,
		"ramo": state.polizas.ramoActual,
		"autos": state.polizas.autos,
		"gm": state.polizas.gm,
		"vida": state.polizas.vida,
		"danios": state.polizas.danios,
		"polizasAutos": state.polizas.autos.length,
		"polizasGm": state.polizas.gm.length,
		"polizasVida": state.polizas.vida.length,
		"polizasDanios": state.polizas.danios.length,
		"pagoPorKilometro": state.polizas.pagoPorKilometro,
		dispositivo: state.global.dispositivo,
		BeneficiosDentalia:state.polizas.BeneficiosDentalia,
		TratamientoDentalia:state.polizas.TratamientoDentalia,
		multicanalGnp: state.multicanalGnp
	};
};

const mapDispatch = (dispatch) => {
	return {
		setRecibo: (oRecibo) => {
			dispatch({ "type": "SET_RECIBO_PAGAR", "recibo": oRecibo });
		},
		setRamoActual: (ramo) => {
			dispatch({"type": "SET_RAMO_ACTUAL", "ramoActual": ramo});
		},
		addEvento: (evento) => {
			dispatch({ "type": "HOME_SET_EVENT", "evento": evento});
		},
		dentaliaBeneficios : (BeneficiosDentalia)=>{
			dispatch(dentaliaBeneficios(BeneficiosDentalia));
		},

		obtenerTratamientoDentalia : (TratamientoDentalia)=>{
			dispatch(obtenerTratamientoDentalia(TratamientoDentalia));
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		getInfo:(mascotasResult)=>{
			dispatch({ "type": "LLENAR_MASCOTA", "mascota": mascotasResult});
		}
	};
};

class DetallePoliza extends React.Component {
	
	state = {
		"showSection": false,
		"verPago": false,
		"mobileTabs": false,
		"secondMenuTitle": "Todas",
		"arrow": [
			require("../img/arrow-down.svg"),
			require("../img/arrow-up.svg")
		],
		"arrowIndex": 0,
		"autosArrowIndex": 0,
		"gmArrowIndex": 0,
		"dañosArrowIndex": 0,
		"vidaArrowIndex": 0,
		"ramo": "Todas",
		multicanalGnp: {
			flujo: null,
			activo: false,
		},
		open_modal: false,
		titulo:'Error en el servicio',
		message: {},
		type_modal: "defaultModal",
		functions: ()=> {}
	};

	handleCallback = (childData) =>{	
		this.setState({showSection: childData})
		console.log(childData)
	}

	showPago = () => {
		this.props.addEvento("BtnPagar");
		if (this.props.poliza.cobranza && this.props.poliza.cobranza.registros && this.props.poliza.cobranza.registros.length > 0) {
			let aRecibos = this.props.poliza.cobranza.registros.sort(function(a,b){ return b.codNumRecibo.localeCompare(a.codNumRecibo);});
			let oRecibo = aRecibos[aRecibos.length -1];
			this.props.setRecibo(oRecibo);
		}
		this.setState({
			"verPago": !this.state.verPago,
		});
	}

	showMobileTabs = () => {
		var arrowIndex;
		if (this.state.arrowIndex == 1) {
			arrowIndex = 0;
		} else if (this.state.arrowIndex == 0) {
			arrowIndex = 1;
		}
		this.setState({
			"mobileTabs": !this.state.mobileTabs,
			"arrowIndex": arrowIndex
		});
	}
	
	verHome = (ramo) => {
		console.log(ramo);
		this.props.setRamoActual(ramo);
		goTo("home");
	}

	componentWillMount = () => {
		let sRamo = this.props.ramo;
		let oPoliza = this.props.poliza;

		if(oPoliza.generales.cveRamo == "" && oPoliza.generales.cveEstatu == "") {
			goTo("home");
		}

		this.props.obtenerTratamientoDentalia(this.props.poliza.generales.numPoliza);
		this.props.dentaliaBeneficios(this.props.poliza.generales.cveRamo);
		this.setState({ "ramo": sRamo });
		
		if(oPoliza.generales.detalle == "capitaliza" || oPoliza.generales.detalle == "inversion") {
			this.showPago();
		}
		if( getVelidateIsMascota(this.props.poliza.generales.productoComercial)) {
			this.mascotaImagenes(this.props.poliza.generales.numPoliza);
		}
	}

	mascotaImagenes = async(numPoliza) => {
		const { type_modal, titulo } = this.state;
			const mascotasResult = await getData('danios/mascotas/configuracion/mc/perfil/polizas/', numPoliza);
			if(mascotasResult && mascotasResult.status === 404) {
				this.setState({
					open_modal: !this.state.open_modal,
					message: { titulo, paragrahp1: mascotasResult.message },
					type_modal,
					functions: {
					  onClose: this.close
					}
				  });
				this.props.getInfo(replaceErrorOnMascota)
			} else {
				this.props.getInfo(mascotasResult)
			}
	}

	close =()=>{
		this.setState({open_modal: !this.state.open_modal})
	}

	showPagoPorKilometro(){
		this.props.tagManager({
			dispositivo: this.props.dispositivo,
			type: " EVENT_CLICK_MOSTRAR_PAGO_POR_KM"
		});
	}

	componentDidMount () {
		window.scrollTo(0, 0);
	}

	componentWillReceiveProps(nextProps){
		if(this.props.multicanalGnp !== nextProps.multicanalGnp){
			this.setState({ multicanalGnp: nextProps.multicanalGnp });
		}
	}

	getWidthScreen = ()=>{
		let width = document.body.clientWidth;
		if(width <= 425){
			return true;
		} else {
			return false;
		}
	}

	render() {
		let totalPolizas = this.props.autos.length + this.props.gm.length + this.props.danios.length + this.props.vida.length;
		let vidaPolizas = this.props.vida.length;
		let daniosPolizas = this.props.danios.length;
		let gmPolizas = this.props.gm.length;
		let autosPolizas = this.props.autos.length;
		const isMascotasPoliza = getVelidateIsMascota(this.props.poliza.generales.productoComercial);
		const {open_modal, type_modal, message, titulo, functions } = this.state;
		let media = this.getWidthScreen();
		const {showSection} = this.state;

		return <div className="container">
			{
				UtilModal(
					{
						modal_text: {
							title_modal: titulo,
							paragrahp1: message.paragrahp1,
							textButtonConfirm: "Aceptar"
						},
						modal_properties: {
							type_modal,
							open_modal,
							mobileQuery: media,
            				nameQuery: "mobileStyles",
						},
					},
					functions
				)
			}
			{/*<img src={ require("../img/arrow-back.svg") } className="scrollToTop" onClick={this.topButton}></img>*/}
			<div className="second-menu text-center hide-mobile">
				<img onClick={this.verHome.bind(this, this.state.ramo)} className="detalle-back-arrow" src={ require("../img/arrow-back.svg") } />
				<ul className="clearfix">
					<li>
						<a onClick={this.verHome.bind(this, "T")}>Todas ({ totalPolizas })</a>
					</li>
					<li>
						<a onClick={this.verHome.bind(this, "A")} className={this.state.ramo === "A" ? "active" : ""}>Autos ({ autosPolizas })</a>
					</li>
					<li>
						<a onClick={this.verHome.bind(this, "G")} className={this.state.ramo === "G" ? "active" : ""}>GMM ({ gmPolizas })</a>
					</li>
					<li>
						<a onClick={this.verHome.bind(this, "V")} className={this.state.ramo === "V" ? "active" : ""}>Vida ({ vidaPolizas })</a>
					</li>
					<li>
						<a onClick={this.verHome.bind(this, "D")} className={this.state.ramo === "D" ? "active" : ""}>Daños ({ daniosPolizas })</a>
					</li>
				</ul>
			</div>

			<div className={this.state.verPago ? "second-menu text-center hide" : "second-menu text-center show-mobile"} >
				<div className="second-menu-select-mobile">
					<img onClick={this.verHome} className="detalle-back-arrow" src={ require("../img/arrow-back.svg") } />
					<p onClick={this.showMobileTabs}>{this.state.secondMenuTitle} <img src={this.state.arrow[this.state.arrowIndex]}></img></p>
					{ this.state.mobileTabs &&
					<ul>
						<li>
							<a onClick={this.verHome.bind(this, "T")}>Todas ({ totalPolizas })</a>
						</li>
						<li>
							<a onClick={this.verHome.bind(this, "A")} className={this.state.ramo === "A" ? "active" : ""}>Autos ({ autosPolizas })</a>
						</li>
						<li>
							<a onClick={this.verHome.bind(this, "G")} className={this.state.ramo === "G" ? "active" : ""}>GMM ({ gmPolizas })</a>
						</li>
						<li>
							<a onClick={this.verHome.bind(this, "V")} className={this.state.ramo === "V" ? "active" : ""}>Vida ({ vidaPolizas })</a>
						</li>
						<li>
							<a onClick={this.verHome.bind(this, "D")} className={this.state.ramo === "D" ? "active" : ""}>Daños ({ daniosPolizas })</a>
						</li>
					</ul>
					}
				</div>
			</div>
			{ this.state.verPago &&
			<PagoPoliza showPago={this.showPago}/>
			}
			<div className="box-wrap">
				<div className="cards-wrap mt-50">
					<div className="row">
						<DescargasPoliza showPago={this.showPago} parentCallback = {this.handleCallback} isMascotasPoliza={isMascotasPoliza}/>
					</div>
					{this.state.showSection && !this.state.verPago &&
						<div className="row">
							<TarjetasFrame/>
						</div>
					}
				</div>
			</div>
			{!this.state.showSection && !this.state.verPago &&
			<div className="box-wrap">
				<div className="cards-wrap mt-50">
					<div className="row">
						{/* <DescargasPoliza showPago={this.showPago}/> */}
						{ this.state.multicanalGnp.activo &&
							<MulticanalFlujos numPoliza={this.props.poliza.generales.numPoliza} flujo={this.state.multicanalGnp.flujo}/>
						}
						{ this.props.poliza.generales && !this.state.multicanalGnp.activo &&
						<div>
							<div className="col-xs-12">
								<h6>Datos Generales</h6>
							</div>
							<div className="col-xs-12">
								<div className="row">
									<div className="col-xs-12 col-md-6 odd-card">
										<GeneralesPoliza />
									</div>
									{ (this.props.poliza.vehiculo || isMascotasPoliza) &&
									<div className="col-xs-12 col-md-6 odd-card">
										<VehiculoPoliza />
									</div>
									}
									{ this.props.poliza.informacionFinanciera &&
									<div className="col-xs-12 col-md-6 odd-card">
										<InformacionFinancieraPoliza />
									</div>
									}
									{ ( this.props.poliza.generales.cveRamo === "G" || this.props.poliza.generales.cveRamo === "D" && !isMascotasPoliza) && this.props.poliza.generales.pendientePago &&
									<div className="col-xs-12 col-md-6 odd-card">
										<CobranzaPoliza />
									</div>
									}
								</div>
							</div>
						</div>
						}
						{ this.props.poliza.generales.pendientePago &&
						 ( this.props.poliza.generales.cveRamo === "A" || this.props.poliza.generales.cveRamo === "V" || (this.props.poliza.generales.cveRamo == "D" && isMascotasPoliza )) &&
						  !this.state.multicanalGnp.activo &&
						<div>
							<div className="col-xs-12 mt-34">
								<h6>Cobranza</h6>
							</div>
							<div className="col-xs-12">
								<div className="row">
									<div className="col-xs-12">
										<CobranzaPoliza />
									</div>
								</div>
							</div>
						</div>
						}
						{ !this.state.multicanalGnp.activo &&
							<div className="col-xs-12 mt-34">
								<h6>Datos Personales</h6>
							</div>
						}
						<div className="col-xs-12">
							{ this.props.poliza.contratante&& !this.state.multicanalGnp.activo &&
								<ContratantePoliza />
							}
							{ this.props.poliza.conductor && !this.state.multicanalGnp.activo &&
								<ConductorPoliza />
							}
							{ this.props.poliza.generales.cveRamo === "A" && 
								<div className="row">
									{ (this.props.poliza.beneficiario || this.props.poliza.beneficiariosReferencia) && !this.state.multicanalGnp.activo &&
										<div className="col-xs-12 col-md-6">
											<BeneficiarioPoliza />
										</div>
									}
									<div className="col-xs-12 col-md-6">
										<TarjetaCirculacion />
									</div>
								</div>
							}
							{ ( this.props.poliza.generales.cveRamo === "V" && this.props.poliza.generales.cveProdTecnico === "V1011ATRAD" && 
							( this.props.poliza.generales.cveProdComercial === "00002" || this.props.poliza.generales.cveProdComercial === "00004" ) ) 
							&& !this.state.multicanalGnp.activo && 
								<BeneficiarioPoliza />
							}
						</div>
						{ this.props.poliza.asegurados && !this.state.multicanalGnp.activo &&
							<AseguradosPoliza />
						}
						{ ( isMascotasPoliza ) && !this.state.multicanalGnp.activo &&
							<div>
								<div className="col-xs-12 col-md-6 odd-card mt-30">
									<PhotosMascotaCmpt />
								</div>
								<div className="col-xs-12 col-md-6 odd-card mt-30">
								   <TarjetaVacunacion />
								</div>
							</div>

						}
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-edocuenta" tabIndex="-1" role="dialog" aria-labelledby="modal-descargar-documento">
					<div className="modal-dialog" role="document">
						<div className="modal-content container">
							<DescargaEdoCuenta />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-recibos" tabIndex="-1" role="dialog" aria-labelledby="modal-descargar-documento">
					<div className="modal-dialog" role="document">
						<div className="modal-content container">
							<DescargaRecibos />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-facturas" tabIndex="-1" role="dialog" aria-labelledby="modal-facturas">
					<div className="modal-dialog" role="document">
						<div className="modal-content container">
							<DescargaFacturas documento="Descarga de facturas" modal="facturas"/>
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-dentalia" tabIndex="-1" role="dialog" aria-labelledby="modal-dentalia">
					<div className="modal-dialog" role="document">
						<div className="modal-content container">
							<Dentalia  />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-finiquitos" tabIndex="-1" role="dialog" aria-labelledby="modal-finiquitos">
					<div className="modal-dialog" role="document">
						<div className="modal-content container">
							<DescargaFiniquitos />
						</div>
					</div>
				</div>
				<div className="modal fade modal-msj" id="modal-ppkilometro" tabIndex="-1" role="dialog" aria-labelledby="modal-ppkilometro">
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<DetallePagoPorKilometro />
						</div>
					</div>
				</div>
			</div>
			}
		</div>;
	}
}
export default connect(mapState, mapDispatch)(DetallePoliza);


// WEBPACK FOOTER //
// ./src/home/detalle.cmpt.js